/* NOTVIX PDP behaviour — gallery, offer picker, AJAX add-to-cart, FAQ, panels.

   Written to survive sections rendering independently: every handler is bound
   by delegation on document, so the FAQ in one section and the buy box in
   another do not need to know about each other, and the theme editor can
   re-render a single section without rewiring anything. */
(function () {
  'use strict';

  /* Two sections both load this file, so the browser executes it twice. Every
     handler below is bound on document, and a second copy would double every
     click: a toggle would close then instantly reopen, and add-to-cart would
     POST twice. Bind once and leave. */
  if (window.__knPdpReady) return;
  window.__knPdpReady = true;

  /* ---------------------------------------------------------- gallery */
  /* The thumbnails are the source of truth for the image list: they already
     carry every full-size URL, so the arrows need no second copy of it. */
  function thumbs() {
    return Array.prototype.slice.call(document.querySelectorAll('.knp-thumb'));
  }

  function currentIndex() {
    var list = thumbs();
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('is-on')) return i;
    }
    return 0;
  }

  function showImage(i) {
    var list = thumbs();
    if (!list.length) return;
    var idx = ((i % list.length) + list.length) % list.length;   /* wraps both ways */
    var shot = document.getElementById('knp-shot-img');
    if (shot && list[idx].dataset.src) shot.src = list[idx].dataset.src;
    list.forEach(function (t, k) { t.classList.toggle('is-on', k === idx); });
    var counter = document.getElementById('knp-count-now');
    if (counter) counter.textContent = idx + 1;
    /* Keep the active thumbnail on screen — with eight photos and five in
       view, arrowing to the seventh would otherwise highlight a tile the
       shopper cannot see. block:nearest stops the page itself jumping. */
    if (list[idx].scrollIntoView) {
      list[idx].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
  }

  /* ---------------------------------------------------------- thumb strip */
  function stripEl() { return document.querySelector('.knp-thumbs'); }

  function syncStripNav() {
    var s = stripEl();
    if (!s) return;
    var prev = document.querySelector('.knp-strip-nav--prev');
    var next = document.querySelector('.knp-strip-nav--next');
    var max = s.scrollWidth - s.clientWidth - 1;
    var scrollable = max > 0;
    if (prev) prev.disabled = !scrollable || s.scrollLeft <= 0;
    if (next) next.disabled = !scrollable || s.scrollLeft >= max;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.knp-strip-nav');
    if (!b) return;
    var s = stripEl();
    if (!s) return;
    s.scrollLeft += Number(b.dataset.dir || 1) * s.clientWidth * 0.8;
  });

  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('knp-thumbs')) syncStripNav();
  }, true);

  window.addEventListener('resize', syncStripNav);

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('.knp-nav');
    if (nav) { showImage(currentIndex() + Number(nav.dataset.dir || 1)); return; }
    var thumb = e.target.closest('.knp-thumb');
    if (thumb) showImage(Number(thumb.dataset.index || 0));
  });

  /* ---------------------------------------------------------- offers */
  function selectedOffer() {
    return document.querySelector('.knp-offer.is-on');
  }

  function syncAtcLabel() {
    var btn = document.getElementById('knp-atc');
    var offer = selectedOffer();
    if (!btn || !offer) return;
    var base = btn.dataset.label || 'Add to cart';
    var price = offer.dataset.price || '';
    btn.textContent = price ? base + ' · ' + price : base;
  }

  document.addEventListener('click', function (e) {
    var offer = e.target.closest('.knp-offer');
    if (!offer) return;
    document.querySelectorAll('.knp-offer').forEach(function (o) { o.classList.remove('is-on'); });
    offer.classList.add('is-on');
    var input = offer.querySelector('input[type="radio"]');
    if (input) input.checked = true;
    syncAtcLabel();
  });

  /* ---------------------------------------------------------- faq */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.knp-q button');
    if (!q) return;
    q.parentElement.classList.toggle('is-open');
  });

  /* ---------------------------------------------------------- info panels */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.knp-panel-head');
    if (!head) return;
    var panel = head.parentElement;
    panel.classList.toggle('is-open');
    head.setAttribute('aria-expanded', panel.classList.contains('is-open') ? 'true' : 'false');
  });

  /* ---------------------------------------------------------- add to cart */
  function addToCart(btn) {
    var offer = selectedOffer();
    var variantId = btn.dataset.variant;
    if (!variantId) return;

    var qty = 1;
    if (offer && offer.dataset.qty) qty = parseInt(offer.dataset.qty, 10) || 1;
    var code = offer ? (offer.dataset.code || '') : '';

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        window.location.href = code
          ? '/discount/' + encodeURIComponent(code) + '?redirect=/cart'
          : '/cart';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#knp-atc');
    if (!btn) return;
    addToCart(btn);
  });

  syncAtcLabel();
  syncStripNav();
})();